import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../IconButton';
import MultimediaAdd from '../../../../features/multimedia/MultimediaAdd';
import MultimediaList from '../../../../features/multimedia/MultimediaList';
import './MediaLibraryDialog.scss';

interface MediaLibraryDialogProps {
  handleClose: () => void;
  showMediaLibrary: boolean;
  handleAssetChoose?: (val: string) => void;
}

const MediaLibraryDialog: FC<MediaLibraryDialogProps> = ({ handleClose, showMediaLibrary, handleAssetChoose }) => {
  const { t } = useTranslation();

  return (
    <Dialog className="MediaLibraryDialog" onClose={handleClose} open={showMediaLibrary} fullWidth maxWidth={false}>
      <DialogTitle className="DialogTitle">
        <div>{t('mediaLibrary.dialog.title')}</div>
        <IconButton icon={faXmark} onClick={handleClose} />
      </DialogTitle>
      <DialogContent dividers>
        <MultimediaAdd doNotRedirect />
        <br />
        <br />
        <MultimediaList handleAssetChoose={handleAssetChoose} />
      </DialogContent>
    </Dialog>
  );
};

export default MediaLibraryDialog;
